import { render, staticRenderFns } from "./CashDesk.vue?vue&type=template&id=360ca5ba&"
import script from "./CashDesk.vue?vue&type=script&lang=js&"
export * from "./CashDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports